import { Box, Typography } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { mcaI20Logo } from "../../../Assets";
import { getPlayersDetails } from "../../../Utils/apiService";
import { useAuthStore } from "../../../store";
import PlayerSection from "./components/PlayerSection";

const IconPlayers = () => {
  const [playerDetails, setPlayerDetails] = useState<any[] | null>(null);

  const { teamDetailsTrigger, teamDetailsDivision } = useAuthStore();
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [playerRes] = await Promise.all([getPlayersDetails()]);

        if (playerRes?.data?.success) {
          const data = playerRes.data?.data;
          const filteredData = data.filter(
            (player: any) =>
              player.recentCompetetionLevel === "Indian senior team" ||
              player.recentCompetitionLevel === "Indian senior team"
          );
          setPlayerDetails(filteredData || []);
        } else {
          setPlayerDetails([]);
        }
      } catch (err) {
        console.error("Error fetching data:", err);
        setPlayerDetails([]);
      }
    };

    fetchData();
  }, [teamDetailsTrigger]);

  const filteredByDivision = useMemo(() => {
    if (!Array.isArray(playerDetails)) return [];

    const expectedGender = teamDetailsDivision === "women" ? "female" : "male";
    return playerDetails
      .filter((player: any) => {
        const gender = `${player?.gender || ""}`.toLowerCase();
        return gender === expectedGender;
      })
      .sort((a: any, b: any) =>
        `${a?.name || ""}`.localeCompare(`${b?.name || ""}`, undefined, {
          sensitivity: "base",
        }),
      );
  }, [playerDetails, teamDetailsDivision]);

  const divisionLabel = teamDetailsDivision === "women" ? "WOMEN'S" : "MEN'S";

  const renderInitialLogo = () => (
    <Box
      sx={{
        width: "100%",
        minHeight: "100%",
        background: "transparent",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: { xs: 2, md: "1.2vw" },
          mb: { xs: 4, md: "1.6vw" },
        }}
      >
        <img src={mcaI20Logo} style={{ height: "4.6vw", width: "auto", minHeight: 72 }} alt="" />
          <Typography sx={{ fontSize: { xs: "1.4rem", md: "2.2vw" }, color: "#fff", fontWeight: 800 }}>
          {`T20 Mumbai League - 2025 ${divisionLabel}`}
        </Typography>
      </Box>
    </Box>
  );

  if (!playerDetails) {
    return renderInitialLogo();
  }

  return (
    <Box
      sx={{
        width: "100%",
        height: "100vh",
        minHeight: "100vh",
        position: "relative",
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "center",
        pt: 0,
        pb: { xs: 1.5, md: "1vw" },
      }}
    >
      <Box
        sx={{
          width: "100%",
          height: "95%",
          display: "flex",
          flexDirection: "column",
          pt: 0,
          px: { xs: 2.2, md: "1.2vw" },
          pb: { xs: 2, md: "0.8vw" },
          minHeight: 0,
        }}
      >
        <Box
          sx={{
            border: "1px solid rgba(255, 124, 24, 0.3)",
            background:
              "linear-gradient(90deg, rgba(50,19,5,0.96) 0%, rgba(110,42,2,0.95) 70%, rgba(227,116,16,0.95) 100%)",
            p: { xs: 1.2, md: "0.55vw" },
            position: "relative",
            mb: { xs: 2, md: "0.8vw" },
            "&::after": {
              content: '""',
              position: "absolute",
              left: 0,
              right: 0,
              bottom: -4,
              height: "4px",
              background:
                "linear-gradient(90deg, #e41f4f 0%, #e41f4f 12%, #24c864 12%, #24c864 26%, #1ba8ff 26%, #1ba8ff 40%, #4e5dff 40%, #4e5dff 54%, #ff8b1a 54%, #ff8b1a 67%, #ff3e4d 67%, #ff3e4d 79%, #ffd400 79%, #ffd400 90%, #22d37b 90%, #22d37b 100%)",
            },
          }}
        >
          <Typography
            sx={{
              color: "#fff",
              fontWeight: 800,
              fontStyle: "italic",
              fontSize: { xs: "1.35rem", md: "2.1vw" },
              lineHeight: 1,
              background: "linear-gradient(90deg, #FF8C1E 0%, #FF3E9A 60%, #FF6B39 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            {`ICON PLAYERS OF THE SEASON - ${divisionLabel}`}
          </Typography>
        </Box>

        <Box
          sx={{
            background:
              "linear-gradient(180deg, rgba(18, 7, 15, 0.55) 0%, rgba(8, 8, 12, 0.52) 100%)",
            border: "1px solid rgba(255,255,255,0.08)",
            px: { xs: 1.2, md: "0.9vw" },
            py: { xs: 1.6, md: "0.9vw" },
            flex: 1,
          }}
        >
          <PlayerSection teamDetails={filteredByDivision} />
        </Box>
      </Box>
    </Box>
  );
};

export default IconPlayers;
